import React from "react";

const Text6 = () => {

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);
    return(
      <>
        <p className="content-heading" id="top">
          Förberedelser  
        </p>
    
      <div className="content-text mt-4">

        <p className="heading2">
          Skräp in ger skräp ut               
        </p>
        <p>
          Det är enkelt att bli lönsam med <i>din</i>BiZ - bara att fylla i hög omsättning, fantastiska försäljningspriser och låga 
          kostnader för att se sin månadslön lyfta. Men utan realistiskt underbyggda data bygger du en glädjekalkyl som varken lurar, 
          hjälper eller glädjer någon.                
        </p>
        <p>
          Det kan krävas både tid och finurlighet att få fram bra input-data. Inte minst om din idé medför etablering i för dig 
          ny/okänd bransch. Men jämför det med att förlora din investering på grund av felkalkyl på allt för lösa antaganden. 
          Inga tomma ord: 10-tusentals nyföretagare i Sverige ger upp på grund av felkalkyl varje år.                 
        </p>

        <p className="heading2 mt-4">
          Skaffa Bra Dataunderlag               
        </p>
        <p>
          För vart och ett av dina planerade erbjudanden behöver du bland annat svar på                 
        </p>
        <ul>
          <li>
            Försäljningspris
          </li>
          <li className="mt-1">
            Rörliga Kostnader 
          </li>
          <li className="mt-1">
            Försäljningsvolymer
          </li>
        </ul>  
        <p>
          Du behöver också en inledande uppskattning av företagets fasta kostnader och en grov vägkarta mot mål.                 
        </p>
         
        <div className="ms-4">
          
          <p className="heading3 mt-4">
            Försäljningspris 
          </p>
          <p>
            För att sätta pris på varje enskilt erbjudande behöver du <i>förstå</i> din marknad.                
          </p>
          <ul>
            <li>
              Målkund (vem, behovsbild, ekonomi, familjesituation …) 
            </li>
            <li className="mt-1">
              Konkurrens (nu - och senare) 
            </li>
            <li className="mt-1">
              Marknadserbjudanden (kundvärde, prisbild/kvalitét, branschnormer …) 
            </li>
          </ul>   
          <p>
            Sedan får du bestämma vilken prismodell du vill använda för att bli framgångsrik <i>nog</i> - 
            under de förutsättningar som din marknadsanalys beskriver.
          </p>   
          <p>
            För att sticka ut i din bransch vill du kanske att prisbilden ligger lägre/högre än konkurrenternas.
            Eller kanske ett högpris- och ett lågprisspår parallellt - och så vidare.
            Prismodellen är ett tungt konkurrensvapen som kan ändras, justeras, kalibreras.
          </p>     
              
          <p className="heading3 mt-4">
            Rörliga Kostnader  
          </p>
          <p>
            Avser kostnader som ökar och minskar i direkt proportion till erbjudandets tillverknings- och försäljningsvolym. 
            Exempelvis material, insatsvaror, tillverkning, tillsatser, förpackning, frakt, extra-personal, agentprovision.                  
          </p>
          <p>
            Lokalhyra däremot eller bankränta betalas löpande - ofta opåverkat av mindre variationer i affärsvolymer - och tillhör 
            därför dina Fasta Kostnader. 
          </p>
          <p>
            Gör en lista över varje erbjudandes rörliga kostnader och för in summan i fältet: {"<"}Rörlig Kostnad{">"}.  
          </p>
      
          <p className="heading3 mt-4">
            Försäljningsvolymer                
          </p>
          <p>
            Kräver lite kalkylering. Lägre pris ger oftast ökad försäljningsvolym men sänker du för mycket äts volymökningen upp 
            av lägre intäkt per affär. Se vidare under menyval "Optimerad lönsamhet".
          </p>
        </div>

        <p className="heading2 mt-4">
          Fasta Kostnader                
        </p>
        <p>
          Gör en lista över dina fasta kostnader och visa den för en småföretagare oavsett bransch. 
          Det kan vara någon som du       
        </p>
        <ul>
          <li>
            Känner
          </li>
          <li className="mt-1">
            Känner till 
          </li>
          <li className="mt-1">
            Letar upp 
          </li>
          <li className="mt-1">
            Springer på 
          </li>
          <li className="mt-1">
            Får tips om 
          </li>
        </ul>    
        <p>
          Fråga hur vettig listan ser ut, vad som saknas, vad som felvärderats.
        </p>           
  
        <p className="heading2 mt-4">
          Åtgärder 
        </p>
        <p>
          Bara du vet vilka steg du behöver ta för att gå i mål med ditt projekt. Men du kan ändå ha glömt ett och annat. 
          Du kan få professionell hjälp att dubbelkolla din åtgärdslista på Nyföretagarcentrum, ”kuvöser” och ”acceleratorer” 
          för startups samt av företagsrådgivare på banken du anlitar - exempelvis.
        </p>

        <p className="heading2 mt-4">
          Fråga för Svar!
        </p>
        <p>
          Du kan så klart göra en egocentrerad uppskattning av relevant data, med risk att missa grovt. Säkrare är att fråga 
          utomstående som
        </p>
        <ul>
          <li>
            Potentiella företagskunders marknadsavdelning, inköpsavdelning  o s v 
            <ul>
              <li className="mt-1">
                Konkurrenters nöjda referenskunder 
              </li>
              <li className="mt-1">
                Konkurrenters missnöjda kunder där de kan identifieras
              </li>
            </ul>
          </li>
          <li className="mt-1">
            eller representativa kunder ur allmänheten om du vänder erbjudandet dit 
          </li>
          <li className="mt-1">
            Tilltänkta leverantörer (kostnader, leveransvillkor, alternativ)
          </li>
          <li className="mt-1">
            Branschorganisationer
          </li>
          <li className="mt-1">
            Branschkunniga kolleger, vänner, bekanta
          </li>
          <li className="mt-1">
            M fl 
          </li>
        </ul>        

        <p>
          Studera dina indata som kan variera rejält mellan olika intervjuobjekt. Vilka behov har din 
          målkund där din tjänst bidrar till en lösning? Vilka egenskaper efterfrågas idag - och vilka trender ser du frammåt? 
          Det är svaren på sådana frågor som ger underlag för dina svåra affärsbeslut.
        </p>       
        <ul>
          <p>Tips vid intervjuer:</p>  
          <li>
            Undvik att avslöja hela din affärsidé i dina ”intervju”-samtal som kan ske helt informellt över en kopp kaffe.   
          </li>
          <li className="mt-1">
            Undvik överhuvudtaget att prata själv fast du gärna vill - det stjäler intervjutid och exponerar dig på ett sätt 
            som kan påverka svaren du får 
          </li>
          <li className="mt-1">
            Ställ istället öppna, relevanta och väl avgänsade frågor, som kan <i>engagera</i> tillfrågad och ge dig de 
            svar du behöver. Med ”öppna” avses här motsatsen till ”Ja/Nej-frågor”. 
          </li>
          <li className="mt-1">
            Blir du stoppad i telefonväxeln - säg som det är: Du säljer ingenting utan arbetar med att sammanställa branschdata. 
            Du behöver bara några färska uppgifter. 
          </li>
        </ul>               

      </div>
    </>
  );
}
export default Text6;